'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { Loading } from './components';

export default function NotFound() {
  const pathname = usePathname();

  const getRedirectHost = (host: string): string => {
    if (host.includes('joy.')) {
      return 'https://tamjaimixian.com';
    }
    if (host.includes('samgor.')) {
      return 'https://www.tjsamgor.com';
    }
    return host;
  };

  useEffect(() => {
    // 在客户端执行重定向
    const host = window.location.host;
    const redirectUrl = getRedirectHost(host) + pathname;
    console.log('404 page redirect to:', redirectUrl);
    window.location.href = redirectUrl;
  }, [pathname]);

  // 返回加载状态的 UI
  return (
    <div style={{ height: '100vh' }}>
      <Loading />
    </div>
  );
}
